import { useSyncExternalStore } from 'react';

/** Alles, Productie, Test or Lab on the overview pages: one choice, remembered in this browser, the same on each page. */
export type KindFilter = 'all' | 'prod' | 'test' | 'lab';

export const KIND_LABEL: Record<KindFilter, string> = { all: 'Alles', prod: 'Productie', test: 'Test', lab: 'Lab' };

const KEY = 'v2.kind';
const KINDS: KindFilter[] = ['all', 'prod', 'test', 'lab'];

const read = (): KindFilter => {
    try {
        const raw = window.localStorage.getItem(KEY) as KindFilter | null;
        return raw && KINDS.includes(raw) ? raw : 'all';
    } catch {
        return 'all';
    }
};

let current: KindFilter = read();
const listeners = new Set<() => void>();

const set = (kind: KindFilter) => {
    current = kind;
    try {
        window.localStorage.setItem(KEY, kind);
    } catch {
        // Storage that is off only costs remembering it after a reload.
    }
    listeners.forEach((l) => l());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const useKindFilter = (): [KindFilter, (kind: KindFilter) => void] => [useSyncExternalStore(subscribe, () => current), set];
